import loader from '../moduleLoader.js';

class Search {
    constructor(button) {
        this.button = button;
        this.searchContainer = document.getElementById(button.getAttribute('aria-controls'));
        this.searchContainer.addEventListener('click', e => {
            e.stopPropagation();
        });
    }
    init() {
        this.button.addEventListener('click', this.toggle.bind(this));
        // this.searchContainer.style.visibility = 'hidden'; 
    }
    toggle(e) {
        e.preventDefault();
        e.stopPropagation();
        if(this.button.getAttribute('aria-expanded') == 'true') {
            this.close();
        }
        else {
            this.open();
        }
    }
    open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.searchContainer.parentElement.classList.add('header--search-open');        
        document.body.addEventListener('click', this.close.bind(this));
        document.addEventListener('keydown', this.handleEscKey.bind(this));
        // this.searchContainer.style.visibility = null;

        // create invisible dummy input to receive the focus first (iOS issue)
        const fakeInput = document.createElement('input')
        fakeInput.setAttribute('type', 'text')
        fakeInput.style.position = 'absolute'
        fakeInput.style.opacity = 0
        fakeInput.style.height = 0
        fakeInput.style.fontSize = '16px' // disable auto zoom

        // you may need to append to another element depending on the browser's auto 
        // zoom/scroll behavior
        document.body.prepend(fakeInput)

        // focus so that subsequent async focus will work
        fakeInput.focus()

        setTimeout(() => {
            //real focus
            document.getElementById('SearchField').focus();
            // cleanup
            fakeInput.remove()
        }, 400);
    }
    
    close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.searchContainer.parentElement.classList.remove('header--search-open');
        document.body.removeEventListener('click', this.close.bind(this));
        document.removeEventListener('keydown', this.handleEscKey.bind(this));
        this.button.focus();
        // setTimeout(() => {
            // this.searchContainer.style.visibility = 'hidden'; //Hide from keyboard navigation
        // }, 400);   
    }
    handleEscKey(e) {    
        if (e.key === 'Escape') {
            this.close();
        }
    }
}

loader.add('Search', Search);

export default Search;